// Serialization
import { deserialize } from 'serializr';
import { alertingSchema } from './schemas';

/**
* Serialization
*/
const deserializeAlerting = (data) => deserialize(alertingSchema, data);

/**
* Lists
*/
const alertingMedias = ['email', 'sms'];

/**
* Model
*/
const alerting = {
  // Name
  name: 'alerting',

  // Serialization
  deserialize: deserializeAlerting,

  // Lists
  medias: alertingMedias,
};

module.exports = alerting;



// WEBPACK FOOTER //
// ./models/alerting.js